import React from 'react';
import { Card } from 'antd';
// import Trophies from './Trophies';

interface PrizeCardProps {
    title: string;
    desc: (string | { item: string; subItems: string[] })[];
    footer?: string;
}

const splitEmoji = (str: string) => {
    const match = str.match(/^(\p{Emoji_Presentation}|\p{Emoji}\uFE0F?)\s*(.*)$/u);
    if (match) {
        return { emoji: match[1], text: match[2] };
    }
    return { emoji: null, text: str };
};

const PrizeCard = ({ title, desc, footer }: PrizeCardProps) => {
    return (
        <Card
            title={title}
            headStyle={{
                borderBottom: '1px solid #d1d5db',
                textAlign: 'center',
                minHeight: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            bodyStyle={{
                padding: '16px 16px',
            }}
            className="border border-gray-200 shadow prize-card"
        >
            <div className="text-gray-700 text-center">
                {desc.map((item, index) => {
                    if (typeof item === 'string') {
                        const { emoji, text } = splitEmoji(item);
                        return (
                            <div key={index} className="mb-2">
                                <div className="font-bold text-gray-900">
                                    {emoji && <span className="mr-1">{emoji}</span>}
                                    {text}
                                </div>
                            </div>
                        );
                    }

                    const { emoji, text } = splitEmoji(item.item);
                    return (
                        <div key={index} className="mb-2">
                            <div className="font-bold text-gray-900">
                                {emoji && <span className="mr-1">{emoji}</span>}
                                {text}
                            </div>
                            {item.subItems.map((subItem, subIndex) => (
                                <div key={subIndex} className="text-gray-600">
                                    {subItem}
                                </div>
                            ))}
                        </div>
                    );
                })}
            </div>
            {footer && (
                <div className="mt-2 text-gray-600 text-center">
                    {footer}
                </div>
            )}
        </Card>
    );
};

export default PrizeCard;
